import React from 'react'
import { Tooltip } from '@mobi/component-library/Common/V2/Tooltip'
import { QuickShare } from '@core/Areas/FollowMe/Components/QuickShare'
import { FloatingActionButton } from './Components/FloatingActionButton'
import { useOutsideClick } from 'rooks'
import { useOnboardingTooltips } from '@core/Areas/FollowMe/hooks/useOnboardingTooltips'

export const QuickShareButton: React.FC = () => {
  const [isQuickShareOpen, setIsQuickShareOpen] = React.useState(false)

  const handleQuickShareClick = () => setIsQuickShareOpen(curr => !curr)
  const handleQuickShareDismiss = () => setIsQuickShareOpen(curr => !curr)

  const shareBetTooltipRef = React.useRef<HTMLDivElement>(null)
  const { currentTooltipId, onDismissed } = useOnboardingTooltips('bet-loop-share-bet-button')
  const shouldShowTooltip = currentTooltipId === 'bet-loop-share-bet-button'
  useOutsideClick(shareBetTooltipRef, () => {
    if (shouldShowTooltip) onDismissed('bet-loop-share-bet-button')
  })

  return (
    <>
      <QuickShare isOpen={isQuickShareOpen} onDismiss={handleQuickShareDismiss} />

      <FloatingActionButton
        label='Share a Bet'
        iconName='CustomAddBet'
        onClick={handleQuickShareClick}
        tooltipRef={shareBetTooltipRef}
      />

      {shouldShowTooltip && (
        <Tooltip
          color='blue'
          triggerElRef={shareBetTooltipRef}
          tooltipId='bet-loop-share-bet-button'
          hasTooltipBeenSeen={() => false}
          shouldHideCrossIcon
          shouldOnlyRenderSingleInstance={true}
          offsetYPx={7}
          offsetXPx={8}
          onDismissed={() => onDismissed('bet-loop-share-bet-button')}
          strategyPosition='fixed'
          preferredPlacement='top'
        >
          <div style={{ minWidth: '11.2rem' }}>Share your</div>
          <div>pending bets</div>
        </Tooltip>
      )}
    </>
  )
}
